'use strict';

exports.__esModule = true;
exports.default = defined;

var _isSome = require('./isSome');

var _isSome2 = _interopRequireDefault(_isSome);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function defined() {
  for (var _len = arguments.length, items = Array(_len), _key = 0; _key < _len; _key++) {
    items[_key] = arguments[_key];
  }

  if (Array.isArray(items)) {
    return items.every(function (item) {
      return !(0, _isSome2.default)(item, null, undefined);
    });
  }
  return false;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-validation-mixin/lib/utils/defined.js
// module id = 2794
// module chunks = 1